import { Box, IconButton, SlideFade, Tooltip, useDisclosure, VStack } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { WhatAppIcon, WidgetChatIcon, WidgetEmailIcon } from '../assets/icons/icons';

export const FloatingWidget = () => {
  const { isOpen, onToggle } = useDisclosure();

  const whatsAppAction = () => {
    const whatsappLink = `https://wa.me/2349021516899?text=Hi%20there%2C%20I%20would%20like%20to%20make%20an%20inquiry%20from%20the%20Credo%20by%20eTranzact%20team.%20Thank%20you`;
    window.open(whatsappLink, '_blank');
  };

  const menuItems = [
    {
      icon: <WidgetEmailIcon />,
      label: 'Sen email to support',
      onClick: () => {
        window.location.href = 'mailto:help@credocentral.com';
      },
      color: 'blackAlpha',
    },
    {
      icon: <WhatAppIcon />,
      label: 'Whatsapp',
      onClick: whatsAppAction,
      color: 'whatsapp',
    },
  ];
  return (
    <Box position="fixed" bottom="6" right="6" zIndex="dropdown">
      <VStack spacing={4} align="center">
        {isOpen && (
          <SlideFade in={isOpen} offsetY="20px">
            <VStack spacing={3}>
              {menuItems.map((item, index) => (
                <Tooltip
                  key={index}
                  label={item.label}
                  placement="left"
                  hasArrow
                >
                  <IconButton
                    icon={item.icon}
                    aria-label={item.label}
                    colorScheme={item.color ?? 'grey'}
                    bgGradient={item.label === 'whatsapp' ? 'linear(to-b, #62FA7F 0%, #22CC40 68.6%, #05B723 100%)' : undefined}
                    size="lg"
                    isRound
                    onClick={item.onClick}
                    _hover={{ transform: 'scale(1.1)', bg: item.color ?? undefined }}
                    transition="all 0.5s"
                  />
                </Tooltip>
              ))}
            </VStack>
          </SlideFade>
        )}
        <IconButton
          icon={isOpen ? <CloseIcon fontSize="sm" /> : <WidgetChatIcon />}
          aria-label="Menu"
          colorScheme="grey"
          bg={'#0644CC'}
          size="lg"
          isRound
          onClick={onToggle}
          boxShadow="xl"
          _hover={{ transform: 'scale(1.1)', boxShadow: 'xl' }}
          transition="all 0.2s"
        />
      </VStack>
    </Box>
  );
};
